module.exports = __webpack_public_path__ + "static/media/foto-mitru-02.41350a49.jpg";